import { PaymentMethodConfiguration } from '../model';
import { PaymentMethodConfigurationEnricher } from './paymentMethodConfigurationEnricher';

interface PaymentMethodConfigurationProvider {
  get(paymentMethodId: string): PaymentMethodConfiguration;
  getDefault(): PaymentMethodConfiguration;
}

const DEFAULT_PAYMENT_METHOD_CONFIGURATION: PaymentMethodConfiguration = {
  copyableText: {
    type: 'standard',
  },
  informationBlock: {
    type: 'standard',
  },
  qrCode: {
    type: 'square',
    behaviourType: 'image',
  },
  paymentResult: {
    paymentMethodLogo: 'displayed',
    completionBehaviour: 'keepInformation',
  },
};

const encrichConfiguration = (): PaymentMethodConfiguration => ({
  copyableText: { ...DEFAULT_PAYMENT_METHOD_CONFIGURATION.copyableText },
  informationBlock: {
    ...DEFAULT_PAYMENT_METHOD_CONFIGURATION.informationBlock,
  },
  qrCode: { ...DEFAULT_PAYMENT_METHOD_CONFIGURATION.qrCode },
  paymentResult: { ...DEFAULT_PAYMENT_METHOD_CONFIGURATION.paymentResult },
});

export const paymentMethodConfigurationProvider: PaymentMethodConfigurationProvider =
  {
    get(paymentMethodId: string): PaymentMethodConfiguration {
      const configuration = encrichConfiguration();

      PaymentMethodConfigurationEnricher.enrich(configuration, paymentMethodId);

      return configuration;
    },
    getDefault() {
      return encrichConfiguration();
    },
  };
